<!--
 * @Author: tianshuai 1446360207@qq.com
 * @Date: 2024-08-05 15:25:26
 * @LastEditors: tianshuai 1446360207@qq.com
 * @LastEditTime: 2024-10-15 15:19:40
 * @FilePath: \惠宾官网\src\App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div id="app">
	<top-nav></top-nav>	
	<router-view></router-view>
  </div>
</template>
<script>
	import topNav from "../src/components/topNav"
	export default {
		components:{
			topNav
		},
		data() {
			return {
			}
		},
		beforeRouteLeave(to, from, next) {
			// 在这里强制重新渲染
			next();
		},
		computed: {
			key() {
				return this.$route.path
			}
		},
		watch: {
		},
		
		created() {
		},
		methods: {
			
		},
		mounted () {
			
		}
	}
</script>
<style>
	@import url(assets/css/reset.css);
	@import url(assets/css/fullpage.min.css);
	
	@import url(assets/css/style.scss);
	@import url(assets/css/media.css);
	body{
		height: 100%;
		/* padding-top: 8rem; */
		background-color: #ffffff !important;
	}
	.navbar{
		border-radius: 0 !important;
	}
</style>
